<template>
  <div>
    <svg
      v-if="size == 'small'"
      class="rotating"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="10" stroke="#B2BCC6" stroke-width="4" />
      <path
        d="M21.2978 8.31875C21.8396 9.6874 22.0727 11.1588 21.9803 12.6279C21.8878 14.097 21.4722 15.5276 20.7631 16.8175C20.0539 18.1075 19.0687 19.2249 17.8779 20.0902C16.687 20.9554 15.3198 21.547 13.8738 21.8229C12.4279 22.0987 10.9389 22.0519 9.5131 21.6858C8.08733 21.3198 6.75997 20.6434 5.62576 19.7051C4.49155 18.7668 3.57848 17.5897 2.95173 16.2578C2.32498 14.9259 2 13.472 2 12"
        stroke="#0075DB"
        stroke-width="4"
        stroke-linecap="square"
      />
    </svg>
    <svg
      v-else-if="size == 'medium'"
      class="rotating"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="16" cy="16" r="14" stroke="#B2BCC6" stroke-width="4" />
      <path
        d="M29.0169 10.8463C29.7755 12.7624 30.1018 14.8223 29.9724 16.8791C29.843 18.9358 29.2611 20.9386 28.2683 22.7446C27.2755 24.5505 25.8962 26.1149 24.229 27.3262C22.5618 28.5376 20.6477 29.3659 18.6233 29.752C16.599 30.1382 14.5144 30.0727 12.5183 29.5602C10.5223 29.0477 8.66395 28.1008 7.07606 26.7872C5.48818 25.4736 4.20988 23.8256 3.33242 21.9609C2.45497 20.0962 2 18.0608 2 16"
        stroke="#0075DB"
        stroke-width="4"
        stroke-linecap="square"
      />
    </svg>
    <svg
      v-else
      class="rotating"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="20" cy="20" r="18" stroke="#B2BCC6" stroke-width="4" />
      <path
        d="M36.736 13.3738C37.7114 15.8373 38.1309 18.4858 37.9645 21.1302C37.7981 23.7746 37.05 26.3497 35.7735 28.6716C34.4971 30.9934 32.7237 33.0049 30.5801 34.5623C28.4365 36.1197 25.9756 37.1847 23.3729 37.6812C20.7702 38.1777 18.09 38.0934 15.5236 37.4345C12.9572 36.7756 10.5679 35.5582 8.52637 33.8692C6.4848 32.1803 4.84127 30.0615 3.71311 27.664C2.58496 25.2666 2 22.6496 2 20"
        stroke="#0075DB"
        stroke-width="4"
        stroke-linecap="square"
      />
    </svg>
  </div>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: 'medium'
    }
  }
};
</script>

<style lang="scss" scoped>
@-webkit-keyframes rotating /* Safari and Chrome */ {
  from {
    -webkit-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes rotating {
  from {
    -ms-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -ms-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
.rotating {
  -webkit-animation: rotating 1s linear infinite;
  -moz-animation: rotating 1s linear infinite;
  -ms-animation: rotating 1s linear infinite;
  -o-animation: rotating 1s linear infinite;
  animation: rotating 1s linear infinite;

  width: auto;
  height: auto;
}
</style>
